export default {
  // Add path to missing strings
  missingString(state, path) {
    state.missingStrings.push(path);
  },
};
